export default __webpack_public_path__ + "static/media/fitness.ca1b832b.jpg";